// Client-side mirror of the server's upload cap.
//
// Must stay in step with MAX_FILE_SIZE_MB in server/lib/uploads.js, and nginx's
// client_max_body_size has to sit above both (it's currently 32M, giving the
// multipart encoding a couple of MB of headroom).
//
// The browser check exists purely so a user finds out immediately instead of
// uploading for a minute and then being rejected. The server is the real limit.
export const MAX_UPLOAD_MB = 30;
export const MAX_UPLOAD_BYTES = MAX_UPLOAD_MB * 1024 * 1024;

export const isWithinUploadLimit = (file) => !file || file.size <= MAX_UPLOAD_BYTES;

export const tooLargeMessage = (what = 'That file') =>
  `${what} is too large — the maximum is ${MAX_UPLOAD_MB} MB.`;
